{
  "title": "Estate Status",
  "header-tooltip-description": "Measures how complete a household's estate planning checklist is after excluding items marked N/A.",
  "calculation-tooltip-description": "Completed items earn their full weight, incomplete items earn 0%, and items marked N/A are removed from the denominator.",
  "disabled-message": "Estate Status is not enabled for this firm yet.",
  "loading-message": "Loading estate status...",
  "load-error-message": "Estate Status could not be loaded right now.",
  "calculation-factors": "Calculation Factors",
  "checklist-progress": "Checklist Progress",
  "no-applicable-items": "No applicable checklist items are currently included.",
  "completed-label": "{{completed}} of {{applicable}} applicable {{itemLabel}} complete",
  "item-singular": "item",
  "item-plural": "items",
  "earned-weight": "Earned Weight",
  "applicable-weight": "Applicable Weight",
  "template-weight": "Template Weight",
  "excluded-label": "{{count}} {{itemLabel}} excluded as N/A.",
  "current-score": "Current Score",
  "current-score-description": "Notes and attachments add advisor context. They never change the score directly.",
  "hide-details": "Hide Details",
  "last-reviewed-label": "Last Reviewed (Optional)",
  "last-reviewed-empty": "Not reviewed yet",
  "state-label": "Status",
  "client-read-only-description": "This is a read-only view of the estate planning checklist your advisor maintains.",
  "client-empty-message": "Estate Status is not available for this household yet.",
  "date-placeholder": "MM/DD/YYYY",
  "note-label": "Note",
  "note-placeholder": "Add context for this estate item.",
  "attachments-empty": "No attachments uploaded yet.",
  "how-this-adds-up": "How This Adds Up",
  "how-this-adds-up-description": "Yes earns the full item weight. No earns 0% of that item's weight. N/A removes the item weight from the denominator.",
  "save-error-message": "We could not save Estate Status right now. Keep editing to retry automatically.",
  "state-yes": "Yes",
  "state-no": "No",
  "state-na": "N/A",
  "not-applicable": "Not Applicable",
  "math-label": "{{earnedWeight}} of {{applicableWeight}} applicable = {{score}}",
  "details-add": "Add Details",
  "details-note": "Note",
  "details-attachment-singular": "{{count}} Attachment",
  "details-attachment-plural": "{{count}} Attachments",
  "details-note-and-attachments": "Note + {{attachmentLabel}}",
  "item-contribution-excluded": "Excluded",
  "item-contribution-earned": "{{weight}} earned",
  "item-contribution-not-earned": "0% of {{weight}} earned",
  "attachments-heading": "Attachments",
  "attachments-upload": "Upload Attachment",
  "attachments-upload-error": "We could not attach this file right now. Please try uploading it again.",
  "attachments-remove": "Remove",
  "default-checklist-will": "Will",
  "default-checklist-trust": "Trust",
  "default-checklist-financial-poa": "Financial Power of Attorney",
  "default-checklist-healthcare-directive": "Healthcare Directive",
  "default-checklist-beneficiaries": "Beneficiary Designations",
  "default-checklist-guardianship": "Guardianship Provisions",
  "template-new-item-label": "New Checklist Item",
  "template-label-input": "Template item label",
  "template-weight-input": "Template item weight",
  "template-add-item": "Add Item",
  "template-delete-item": "Delete",
  "template-reorder-item": "Reorder {{label}}",
  "template-editor-instructions": "Drag to reorder, rename items, add new labels, and keep the template weights at 100%.",
  "template-empty-state": "No template items yet.",
  "settings-template-name": "Firm Defaults",
  "settings-heading": "Edit {{templateName}}",
  "settings-description": "Customize the default Estate Status checklist your firm uses across households. If an item is not applicable to a household it can be marked as N/A in the household detail.",
  "settings-load-error": "Unable to load the current firm default template right now.",
  "settings-empty-state": "Add at least one Estate Status checklist item to save a firm default template.",
  "settings-save-status-unavailable": "Unavailable",
  "settings-save-status-unavailable-helper": "Unable to load the firm template right now.",
  "settings-save-status-loading": "Loading",
  "settings-save-status-loading-helper": "Loading the current firm default template.",
  "settings-save-status-saving": "Saving",
  "settings-save-status-saving-helper": "Saving your firm default template automatically.",
  "settings-save-status-failed": "Save Failed",
  "settings-save-status-failed-helper": "We could not save the firm default template. Keep editing to retry automatically.",
  "settings-save-status-add-items": "Add Items",
  "settings-save-status-add-items-helper": "Add at least one checklist item before saving.",
  "settings-save-status-label-required": "Label Required",
  "settings-save-status-label-required-helper": "Each checklist item needs a label before saving.",
  "settings-save-status-weight-remaining": "{{weight}} Remaining",
  "settings-save-status-weight-remaining-helper": "Assign the remaining weight before saving.",
  "settings-save-status-weight-over": "{{weight}} Over",
  "settings-save-status-weight-over-helper": "Reduce one or more weights before saving.",
  "settings-save-status-dirty": "Saving Automatically",
  "settings-save-status-dirty-helper": "Valid changes save automatically after you stop editing.",
  "settings-save-status-saved": "Saved",
  "settings-save-status-saved-helper": "All valid template changes are saved automatically."
}
